import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*! Provides core utilities for the working with both versions of the ESRI JSAPI.
 *
 * @ai360/core v33.1.0 (https://bitbucket.org/agvanceskyteam/ai360.client.core.git)
 * SSI DO NOT COPY!!!
 */
import e from "polylabel";
import * as t from "@arcgis/core/geometry/geometryEngine";
import * as n from "@arcgis/core/geometry/support/jsonUtils";
import r from "@arcgis/core/geometry/Multipoint";
import i from "@arcgis/core/geometry/Point";
import o from "@arcgis/core/geometry/Polygon";
import s from "@arcgis/core/geometry/Polyline";
import a from "@arcgis/core/Graphic";
import l from "@arcgis/core/geometry/Extent";
import { geojsonToArcGIS as c } from "@terraformer/arcgis";
import { wktToGeoJSON as g } from "@terraformer/wkt";
import { b as u, T as p } from "../index.js";
import * as f from "@arcgis/core/geometry/projection";
import * as m from "@arcgis/core/geometry/coordinateFormatter";
import h from "@arcgis/core/geometry/SpatialReference";
import d from "@arcgis/core/tasks/GeometryService";
import { reshape as y } from "@arcgis/core/rest/geometryService";
import x from "moment";
import { SpatialReference as R } from "@arcgis/core/geometry";
import * as P from "@arcgis/core/geometry/support/geodesicUtils";

var TempDisableTimer = /*#__PURE__*/function () {
  function TempDisableTimer() {
    _classCallCheck(this, TempDisableTimer);

    this.reset(!0);
  }

  _createClass(TempDisableTimer, [{
    key: "disable",
    value: function disable(e, t, n, r) {
      var _this = this;

      this.disableTimer && clearTimeout(this.disableTimer), this.isTempDisabled || (this.prevState = n), this.isTempDisabled = !0, e(), this.disableTimer = setTimeout(function () {
        _this.disableTimer = null, _this.prevState && t(), _this.isTempDisabled = !1;
      }, r);
    }
  }, {
    key: "reset",
    value: function reset(e) {
      this.disableTimer && clearTimeout(this.disableTimer), this.disableTimer = null, this.isTempDisabled = !1, this.prevState = e;
    }
  }]);

  return TempDisableTimer;
}();

var w = .3048,
    T = 4046.86,
    E = new TempDisableTimer(),
    b = new TempDisableTimer(),
    S = new TempDisableTimer();
var M, A;
!function (e) {
  e[e.LeftToRight = 0] = "LeftToRight", e[e.RightToLeft = 1] = "RightToLeft", e[e.TopToBottom = 2] = "TopToBottom", e[e.BottomToTop = 3] = "BottomToTop";
}(M || (M = {})), function (e) {
  e.KILOMETERS = "kilometers", e.DECIMETERS = "decimeters", e.CENTIMETERS = "centimeters", e.MILLIMETERS = "millimeters", e.METERS = "meters", e.NAUTICAL_MILES = "nautical-miles", e.MILES = "miles", e.YARDS = "yards", e.FEET = "feet", e.INCHES = "inches";
}(A || (A = {}));

var stringFormat = function stringFormat(e, t) {
  for (var n = 0; n < t.length; n++) {
    e = e.replace("{" + n + "}", t[n]);
  }

  return e;
},
    formatNumber = function formatNumber(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return e.toFixed(t).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

var k = Object.freeze({
  __proto__: null,
  stringFormat: stringFormat,
  formatLongDate: function formatLongDate(e) {
    return new Date(e).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric"
    });
  },
  formatNumber: formatNumber,
  getTimeStamp: function getTimeStamp() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
    return x(e).format("YYYY-MM-DD_HH-mm-ss");
  },
  formatLogDetailText: function formatLogDetailText(e) {
    var t = "";

    function addComma() {
      t && (t += ", ");
    }

    return e.addCount > 0 && (t += stringFormat("{0} Records Added", [e.addCount])), e.updateCount > 0 && (addComma(), t += stringFormat("{0} Records Updated", [e.updateCount])), e.exportCount > 0 && (addComma(), t += stringFormat("{0} Records Exported", [e.exportCount])), e.detailsMessage = t, e;
  },
  formatDelimiterString: function formatDelimiterString(e) {
    return e.split(";").filter(function (e) {
      var t = e.trim();
      return t || !1;
    }).join(";");
  },
  parseStringToInt: function parseStringToInt(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ",";
    return null != e && e.replace(new RegExp("\\".concat(t), "g"), "");
  },
  parseStringToNumber: function parseStringToNumber(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ",";
    var n = "," === t ? "." : ",",
        r = e.replace(new RegExp("\\".concat(t), "g"), "").replace(new RegExp("\\".concat(n), "g"), ".");
    return u(r) ? Number(r) : NaN;
  },
  progressiveRoundingDecimals: function progressiveRoundingDecimals(e) {
    return e >= 500 ? 0 : 1;
  },
  progressiveRoundingDecimalsThreeTier: function progressiveRoundingDecimalsThreeTier(e) {
    return e >= 100 ? 0 : e >= 50 ? 1 : 2;
  }
});
f.load(), m.load();

var _createPolygon$1 = function _createPolygon$1(e, t) {
  return new o({
    rings: [e],
    spatialReference: {
      wkid: t.wkid
    }
  });
},
    _createPolylineEdge = function _createPolylineEdge(e, t, n, r) {
  var i = [e.getPoint(t, n), e.getPoint(t, r)];
  return new s({
    paths: [i.map(function (e) {
      return [e.x, e.y];
    })],
    spatialReference: {
      wkid: e.spatialReference.wkid
    }
  });
},
    calculateAbsRawArea = function calculateAbsRawArea(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "acres";
  return Math.abs(calculateRawArea(e, t));
},
    calculateRawArea = function calculateRawArea(e) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "acres";

  if (e) {
    var _i = new h({
      wkid: getUtmZone(e)
    });

    try {
      var _r = f.project(e, _i);

      return null != _r ? t.planarArea(_r, n) : NaN;
    } catch (r) {
      try {
        var _r2 = t.simplify(e);

        if (_r2) {
          var _e = f.project(_r2, _i);

          return null != _e ? t.planarArea(_e, n) : NaN;
        }
      } catch (r) {
        console.error(r);
      }
    }
  }

  return NaN;
},
    getUtmZone = function getUtmZone(e) {
  var t = new h({
    wkid: 4326
  }),
      n = f.project(e.centroid, t),
      r = m.toUtm(n, "north-south-indicators", !0).split(" ")[0];
  return (-1 !== r.indexOf("N") ? 32600 : 32700) + parseInt(r);
},
    getAllPolygonParts = function getAllPolygonParts(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  var n = [];
  return e.forEach(function (e) {
    return n.push.apply(n, _toConsumableArray(getPolygonParts(e, t)));
  }), n;
},
    getCombinedBoundaries$1 = function getCombinedBoundaries$1(e) {
  if (0 === e.length) return null;
  var t = new o({
    spatialReference: new h({
      wkid: e[0].spatialReference.wkid
    })
  });
  return e.forEach(function (e) {
    e.rings.forEach(function (e) {
      t.addRing(e);
    });
  }), t;
},
    almostEqualPolygons = function almostEqualPolygons(e, n) {
  if (t.equals(e, n)) return !0;
  {
    var _r3 = t.symmetricDifference(e, n);

    if (!_r3 || !t.geodesicBuffer(_r3, -.01)) return !0;
  }
  return !1;
},
    getPolygonParts = function getPolygonParts(e) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  if (n) return e.rings.map(function (t) {
    return _createPolygon$1(t, e.spatialReference);
  });
  var r = e.rings.map(function (t) {
    return _createPolygon$1(orientRingAsPolygon(t), e.spatialReference);
  }),
      i = [],
      o = [];
  r.forEach(function (e, n) {
    r.some(function (n) {
      return n !== e && t.equals(n, e);
    }) && !o.some(function (n) {
      return t.equals(n, e);
    }) ? o.push(e) : i.push(e);
  });
  var s = [],
      a = [];
  i.forEach(function (e) {
    var n = r.filter(function (n) {
      return !t.equals(n, e);
    });
    isPolygonAHole(e, n) ? a.push(e) : s.push(e);
  });
  var l = s.sort(function (e, t) {
    return calculateAbsRawArea(t) - calculateAbsRawArea(e);
  }),
      c = a.sort(function (e, t) {
    return calculateAbsRawArea(t) - calculateAbsRawArea(e);
  });
  return l.map(function (e) {
    return c.forEach(function (n) {
      t.contains(e, n) && (e = t.difference(e, n));
    }), e;
  }).concat(o);
},
    describeRing = function describeRing(e, n, r) {
  var i = _createPolygon$1(e, r);

  return {
    index: n,
    points: e,
    geometry: i,
    simplified: t.simplify(i)
  };
},
    isPolygonAHole = function isPolygonAHole(e, n) {
  return n.reduce(function (n, r) {
    return t.contains(r, e) && n.push(r), n;
  }, []).length % 2 != 0;
},
    isPolygonRingAHole = function isPolygonRingAHole(e, t) {
  return calculateRawArea(_createPolygon$1(e, t)) <= 0;
},
    orientRingAsPolygon = function orientRingAsPolygon(e) {
  return new o().isClockwise(e) || e.reverse(), e;
},
    C = {
  almostEqualPolygons: almostEqualPolygons,
  areExtentsEqual: function areExtentsEqual(e, t) {
    return e.xmin === t.xmin && e.ymin === t.ymin && e.xmax === t.xmax && e.ymax === t.ymax;
  },
  calculateAbsRawArea: calculateAbsRawArea,
  calculateArea: function calculateArea(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "acres";
    return formatNumber(calculateAbsRawArea(e, t), 2);
  },
  calculateRawArea: calculateRawArea,
  getUtmZone: getUtmZone,
  clipGeometry: function clipGeometry(e, n) {
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
    return n && (t.overlaps(e, n) || t.within(n, e)) ? t.difference(e, n) : !r && n && t.within(e, n) ? void 0 : e;
  },
  getAllPolygonParts: getAllPolygonParts,
  getAllHolesAsPolygons: function getAllHolesAsPolygons(e) {
    return getAllPolygonParts(e, !0).filter(function (e) {
      return isPolygonRingAHole(e.rings[0], e.spatialReference);
    }).map(function (e) {
      return t.simplify(_createPolygon$1(e.rings[0], e.spatialReference));
    });
  },
  getClippingBoundaries: function getClippingBoundaries(e, t) {
    var n = new o({
      spatialReference: new h({
        wkid: t.wkid
      })
    });
    return e.forEach(function (e) {
      e.rings.forEach(function (e) {
        isPolygonRingAHole(e, t) || n.addRing(e);
      });
    }), n;
  },
  getCombinedBoundaries: getCombinedBoundaries$1,
  getGridMgrs: function getGridMgrs(e) {
    var floorAndFormat = function floorAndFormat(e) {
      var t = 10 * Math.floor(Number(e) / 10);
      return "00000".concat(Math.floor(t % 1e5)).slice(-5);
    },
        _m$toMgrs$split = m.toMgrs(e, "automatic", 5, !0).split(" "),
        _m$toMgrs$split2 = _slicedToArray(_m$toMgrs$split, 4),
        t = _m$toMgrs$split2[0],
        n = _m$toMgrs$split2[1],
        r = _m$toMgrs$split2[2],
        i = _m$toMgrs$split2[3];

    return "".concat(t).concat(n).concat(floorAndFormat(r)).concat(floorAndFormat(i));
  },
  getPolygonParts: getPolygonParts,
  getPolygonBorderWithoutHoles: function getPolygonBorderWithoutHoles(e) {
    return getPolygonParts(e, !0).filter(function (e) {
      return !isPolygonRingAHole(e.rings[0], e.spatialReference);
    }).map(function (e) {
      return t.simplify(_createPolygon$1(e.rings[0], e.spatialReference));
    })[0];
  },
  getLongestSharedBorder: function getLongestSharedBorder(e, n) {
    var sharedBorderLength = function sharedBorderLength(e, n) {
      var r = e.spatialReference,
          i = new s({
        paths: e.rings,
        spatialReference: r
      }),
          o = new s({
        paths: n.rings,
        spatialReference: r
      }),
          a = t.intersect(i, o);
      return a ? t.geodesicLength(a) : 0;
    },
        r = n.sort(function (n, r) {
      var i = t.intersect(e, n),
          o = t.intersect(e, r);
      return i && o ? calculateRawArea(i) - calculateRawArea(o) : i ? 1 : o ? -1 : sharedBorderLength(e, n) - sharedBorderLength(e, r);
    }).pop();

    return t.intersects(e, r) ? r : null;
  },
  getSimplifiedPolygonParts: function getSimplifiedPolygonParts(e) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    if (null == e) return [];
    var r = new o({
      spatialReference: e.spatialReference
    }),
        i = e.rings.map(function (t, n) {
      return describeRing(t, n, e.spatialReference);
    });
    return i.forEach(function (n) {
      var o = n.simplified,
          s = i.some(function (r) {
        if (n.index === r.index || null == o || null == r.geometry) return !1;
        var i = r.simplified;
        return null == i ? isPolygonRingAHole(r.points, e.spatialReference) : t.contains(i, o);
      });
      o && (s ? r.addRing(n.points) : o.rings.forEach(function (e) {
        return r.addRing(e);
      }));
    }), getPolygonParts(r, n);
  },
  getSimplifiedPolygonPartsThatExceedSizeThreshold: function getSimplifiedPolygonPartsThatExceedSizeThreshold(e) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : .001;
    if (null == e) return [];
    var i = new o({
      spatialReference: e.spatialReference
    }),
        s = e.rings.map(function (t, n) {
      return describeRing(t, n, e.spatialReference);
    });
    return s.forEach(function (n) {
      var o = n.simplified;
      if (calculateAbsRawArea(o) < r) return;
      var a = s.some(function (r) {
        if (n.index === r.index || null == o || null == r.geometry) return !1;
        var i = r.simplified;
        return null == i ? isPolygonRingAHole(r.points, e.spatialReference) : t.contains(i, o);
      });
      o && i.addRing(a ? n.points : o.rings[0]);
    }), i.rings.length > 0 ? getPolygonParts(i, n) : null;
  },
  getGraphicWithSmallestArea: function getGraphicWithSmallestArea(e) {
    return e.reduce(function (e, t) {
      var n = C.calculateAbsRawArea(t.geometry);
      return n < e[0] && (e[0] = n, e[1] = t), e;
    }, [Number.MAX_VALUE, new a()])[1];
  },
  getTotalPolygonHoleCount: function getTotalPolygonHoleCount(e) {
    return e.reduce(function (e, t) {
      return e + t.rings.reduce(function (e, n) {
        return e + (isPolygonRingAHole(n, t.spatialReference) ? 1 : 0);
      }, 0);
    }, 0);
  },
  getTotalPolygonPartCount: function getTotalPolygonPartCount(e) {
    return e.reduce(function (e, t) {
      return e + (t && t.rings ? t.rings.length : 0);
    }, 0);
  },
  isMultiPolygon: function isMultiPolygon(e) {
    return e.rings.filter(function (t) {
      return !isPolygonRingAHole(t, e.spatialReference);
    }).length > 1;
  },
  isPolygonAHole: isPolygonAHole,
  isPolygonASliver: function isPolygonASliver(e, n) {
    var r = .0025 * n,
        i = r < 1 ? r : 1,
        o = calculateRawArea(e),
        s = t.geodesicLength(e, "meters");
    if (!o || !s || o < .05) return !0;
    var a = calculateRawArea(e, "square-meters");
    return 4 * Math.PI * (a / Math.pow(s, 2)) < .1 && o < i;
  },
  isPolygonRingAHole: isPolygonRingAHole,
  isValidPolygon: function isValidPolygon(e) {
    var n = t.simplify(e);
    return n && n.rings.length === e.rings.length && !e.isSelfIntersecting;
  },
  lastEdgeSelfIntersects: function lastEdgeSelfIntersects(e) {
    var n = e.rings.length - 1,
        r = e.rings[n].length;

    if (n >= 0 && r > 2) {
      var _i2 = _createPolylineEdge(e, n, r - 1, r - 2);

      for (var _r4 = 0; _r4 < e.rings[n].length - 3; _r4++) {
        var _o = _createPolylineEdge(e, n, _r4, _r4 + 1);

        if (t.intersects(_i2, _o)) return !0;
      }
    }

    return !1;
  },
  mergePolygons: function mergePolygons(e, n) {
    var r = [e, n].sort(function (e, n) {
      return t.geodesicArea(e) - t.geodesicArea(n);
    }),
        _r5 = _slicedToArray(r, 2),
        i = _r5[0],
        s = _r5[1];

    if (s.rings.find(function (t) {
      return isPolygonRingAHole(t, e.spatialReference) && almostEqualPolygons(_createPolygon$1(t, e.spatialReference), i);
    })) {
      var _t = new o({
        spatialReference: e.spatialReference
      });

      return s.rings.forEach(function (n) {
        almostEqualPolygons(_createPolygon$1(n, e.spatialReference), i) || _t.addRing(n);
      }), _t;
    }

    return t.union([e, n]);
  },
  removePolygonHolesSmallerThanThreshold: function removePolygonHolesSmallerThanThreshold(e) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : .001;
    if (null == e) return e;
    var r = new o({
      spatialReference: e.spatialReference
    });
    return e.rings.forEach(function (i) {
      if (isPolygonRingAHole(i, e.spatialReference)) {
        var _o2 = t.simplify(_createPolygon$1(i, e.spatialReference));

        calculateAbsRawArea(_o2) > n && r.addRing(i);
      } else r.addRing(i);
    }), r;
  },
  reshapeGeometries: function reshapeGeometries(e, t) {
    return new Promise(function (n, r) {
      new d({
        url: p.geometryServiceUrl
      });
      var i = e.length;
      var o = [];
      e.forEach(function (e) {
        y(p.geometryServiceUrl, e, t).then(function (t) {
          i--, o.push(t && t.rings.length > 0 ? t : e), 0 === i && n(o);
        });
      });
    });
  },
  splitGeometries: function splitGeometries(e, n) {
    return new Promise(function (r) {
      var i = [];
      e.forEach(function (e) {
        var r = t.cut(e, n);
        r && r.length > 0 ? i.push.apply(i, _toConsumableArray(getAllPolygonParts(r))) : i.push(e);
      }), r(i);
    });
  },
  splitGeometriesNow: function splitGeometriesNow(e, n) {
    if (null == e || null == n) return null;
    var r = [];
    return e.forEach(function (e) {
      var i = t.cut(e, n);
      i && i.length > 0 ? r.push.apply(r, _toConsumableArray(getAllPolygonParts(i))) : r.push(e);
    }), r;
  },
  splitGeometry: function splitGeometry(e, n) {
    var r = [e];
    return n.paths.forEach(function (e) {
      var i = getCombinedBoundaries$1(r),
          o = function (e, t) {
        return new s({
          paths: [e],
          spatialReference: {
            wkid: t.wkid
          }
        });
      }(e, n.spatialReference),
          a = t.cut(i, o);

      r = a && a.length > 0 ? _toConsumableArray(getAllPolygonParts(a)) : [i];
    }), getCombinedBoundaries$1(r);
  },
  esriUnitToMetersConversion: function esriUnitToMetersConversion(e) {
    switch (e) {
      case A.KILOMETERS:
        return 1e3;

      case A.DECIMETERS:
        return .1;

      case A.CENTIMETERS:
        return .01;

      case A.MILLIMETERS:
        return .001;

      case A.METERS:
        return 1;

      case A.NAUTICAL_MILES:
        return 1852;

      case A.MILES:
        return 1609.34;

      case A.YARDS:
        return .9144;

      case A.FEET:
        return .3048;

      case A.INCHES:
        return .0254;

      default:
        return 1;
    }
  }
},
    N = new TempDisableTimer(),
    v = new TempDisableTimer(),
    I = new TempDisableTimer(),
    D = p.minimumAcreage,
    _createPolygon = function _createPolygon(e, t) {
  return new o({
    rings: e,
    spatialReference: {
      wkid: t
    }
  });
},
    _createPolyline = function _createPolyline(e, t) {
  return new s({
    paths: e,
    spatialReference: {
      wkid: t
    }
  });
},
    _findNextPoint = function _findNextPoint(e, t, n) {
  var r = t;

  for (; r + 1 !== t;) {
    r = r + 1 >= n.rings[e].length ? 0 : r + 1;

    var _i3 = n.getPoint(e, r);

    if (!arePointsEqual(n.getPoint(e, t), _i3)) return _i3;
  }

  return null;
},
    _findPreviousPoint = function _findPreviousPoint(e, t, n) {
  var r = t;

  for (; r - 1 !== t;) {
    r = r - 1 < 0 ? n.rings[e].length - 1 : r - 1;

    var _i4 = n.getPoint(e, r);

    if (!arePointsEqual(n.getPoint(e, t), _i4)) return _i4;
  }

  return null;
},
    _nextPointHasMatch = function _nextPointHasMatch(e, t) {
  return e.find(function (e) {
    return arePointsEqual(e, t);
  });
},
    _getMatchingPoints = function _getMatchingPoints(e, t, n, r, i, o) {
  var s = [e, t],
      a = getPolygonPoints(r, i),
      l = a.findIndex(function (t) {
    return arePointsEqual(t, e);
  }),
      c = a.findIndex(function (e) {
    return arePointsEqual(e, t);
  }),
      _ref = l < c ? [_findNextPoint, function (e) {
    return e + 1 !== o;
  }, function (e) {
    return e + 1 >= r.rings[i].length ? 0 : e + 1;
  }] : [_findPreviousPoint, function (e) {
    return e - 1 !== o;
  }, function (e) {
    return e - 1 < 0 ? r.rings[i].length - 1 : e - 1;
  }],
      _ref2 = _slicedToArray(_ref, 3),
      g = _ref2[0],
      u = _ref2[1],
      p = _ref2[2];

  var f = p(o),
      m = g(i, f, r);

  for (; u(f) && m && _nextPointHasMatch(n, m);) {
    s.push(m), f = p(f), m = g(i, f, r);
  }

  return s;
},
    _getProjectionAreaRatio = function _getProjectionAreaRatio(e) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "square-feet";
  return t.planarArea(e, n) / t.geodesicArea(e, n);
},
    areEqual = function areEqual(e, t) {
  return e.toJSON && t.toJSON && JSON.stringify(e.toJSON()) === JSON.stringify(t.toJSON());
},
    arePointsEqual = function arePointsEqual(e, t) {
  return e.x === t.x && e.y === t.y;
},
    arePointsEqualish = function arePointsEqualish(e, t) {
  return Math.abs(e.x - t.x) < p.pointTolerance && Math.abs(e.y - t.y) < p.pointTolerance;
},
    calculateArea = function calculateArea(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "acres";
  return t ? C.calculateArea(e, n) : C.calculateAbsRawArea(e, n);
},
    calculateMinMaxRangeForGridCells = function calculateMinMaxRangeForGridCells(e) {
  var t = o.fromExtent(e),
      n = Math.sqrt(_getProjectionAreaRatio(t)),
      r = Math.max(e.width, e.height) / n;
  return [Math.pow(r / Math.sqrt(p.sampling.maxGridCellCount), 2) / 4046.86, Math.pow(r / Math.sqrt(p.sampling.minGridCellCount), 2) / 4046.86];
},
    createGridCells = function createGridCells(e, _ref3, _ref4, g) {
  var _getCellSize3, _getCellSize4;

  var t = _ref3.areaAcres,
      n = _ref3.cellHeightFt,
      r = _ref3.cellWidthFt;

  var _ref5 = _slicedToArray(_ref4, 2),
      s = _ref5[0],
      c = _ref5[1];

  var u = o.fromExtent(e);

  _getProjectionAreaRatio(u);

  var getCellSize = function getCellSize(_ref6) {
    var e = _ref6.areaAcres,
        t = _ref6.cellHeightFt,
        n = _ref6.cellWidthFt;
    var r,
        i,
        o = e;
    return null != o ? (r = Math.sqrt(4046.86 * o), i = r) : null != t && null != n && (r = .3048 * n, i = .3048 * t, o = r * i / 4046.86), [r, i, o];
  };

  var _getCellSize = getCellSize({
    areaAcres: t,
    cellHeightFt: n,
    cellWidthFt: r
  }),
      _getCellSize2 = _slicedToArray(_getCellSize, 3),
      p = _getCellSize2[0],
      m = _getCellSize2[1],
      h = _getCellSize2[2];

  h || (_getCellSize3 = getCellSize({
    areaAcres: s,
    cellHeightFt: null,
    cellWidthFt: null
  }), _getCellSize4 = _slicedToArray(_getCellSize3, 3), p = _getCellSize4[0], m = _getCellSize4[1], h = _getCellSize4[2], _getCellSize3);
  var d = e.height - e.width;

  if (d > 0) {
    var _t2 = d / 2;

    e.xmin = e.xmin - _t2, e.xmax = e.xmax + _t2;
  } else {
    var _t3 = Math.abs(d) / 2;

    e.ymin = e.ymin - _t3, e.ymax = e.ymax + _t3;
  }

  var _ref7 = [e.xmin, 0, 0],
      y = _ref7[0],
      x = _ref7[1],
      w = _ref7[2];
  var T = new R({
    wkid: 4326
  }),
      E = [],
      b = e.xmin,
      S = e.ymin,
      M = f.project(new i({
    x: b,
    y: S,
    spatialReference: e.spatialReference
  }), T),
      A = f.project(new i({
    x: e.xmax,
    y: e.ymax,
    spatialReference: e.spatialReference
  }), T);
  var k = M.x;
  var C = [b];

  for (; k < A.x || C.length < 2;) {
    var _t4 = new i({
      x: k,
      y: M.y
    }),
        _n = P.pointFromDistance(_t4, p, 90);

    k = null == _n ? void 0 : _n.x;

    var _r6 = f.project(_n, e.spatialReference);

    C.push(_r6.x);
  }

  var N = M.y;
  var v = [S];

  for (; N < A.y || v.length < 2;) {
    var _t5 = new i({
      x: M.x,
      y: N
    }),
        _n2 = P.pointFromDistance(_t5, m, 0);

    N = null == _n2 ? void 0 : _n2.y;

    var _r7 = f.project(_n2, e.spatialReference);

    v.push(_r7.y);
  }

  var I = C[0],
      D = C[C.length - 1],
      L = v[0],
      F = v[v.length - 1],
      B = new l({
    xmin: I,
    ymin: L,
    xmax: D,
    ymax: F,
    spatialReference: e.spatialReference
  }),
      H = Math.abs(e.center.x - B.center.x),
      q = Math.abs(e.center.y - B.center.y);

  for (var _i5 = 0; _i5 < C.length - 1; _i5++) {
    for (var _t6 = 0; _t6 < v.length - 1; _t6++) {
      E.push(new a({
        geometry: _createPolygon([[[C[_i5] + H, v[_t6] + q], [C[_i5] + H, v[_t6 + 1] + q], [C[_i5 + 1] + H, v[_t6 + 1] + q], [C[_i5 + 1] + H, v[_t6] + q], [C[_i5] + H, v[_t6] + q]]], e.spatialReference.wkid),
        attributes: {
          col: _i5,
          id: w,
          row: _t6
        },
        symbol: g
      })), w++;
    }
  }

  return E;
},
    createPolyline = function createPolyline(e) {
  return _createPolyline([e.map(function (e) {
    return [e.x, e.y];
  })], e && e.length ? e[0].spatialReference.wkid : 4326);
},
    getPolygonPoints = function getPolygonPoints(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NaN;
  var n = [];
  if (isNaN(t)) for (var _r8 = 0; _r8 < e.rings.length; _r8++) {
    for (var _t7 = 0; _t7 < e.rings[_r8].length; _t7++) {
      n.push(e.getPoint(_r8, _t7));
    }
  } else for (var _r9 = 0; _r9 < e.rings[t].length; _r9++) {
    n.push(e.getPoint(t, _r9));
  }
  return n;
},
    getPolyLabelPoint = function getPolyLabelPoint(t) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : p.labelPlacementPrecision;
  var r = e(t.rings, n);
  return new i({
    x: r[0],
    y: r[1],
    spatialReference: t.spatialReference
  });
},
    getPolylinePoints = function getPolylinePoints(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NaN;
  var n = [];
  if (isNaN(t)) for (var _r10 = 0; _r10 < e.paths.length; _r10++) {
    for (var _t8 = 0; _t8 < e.paths[_r10].length; _t8++) {
      n.push(e.getPoint(_r10, _t8));
    }
  } else for (var _r11 = 0; _r11 < e.paths[t].length; _r11++) {
    n.push(e.getPoint(t, _r11));
  }
  return n;
},
    isPoint = function isPoint(e) {
  return "point" === e.type;
},
    applyPointTransformation = function applyPointTransformation(e, t, n) {
  if (!t) return e;
  {
    var _r12 = n.toMap(n.toScreen(e));

    _r12.x = _r12.x - t.dx, _r12.y = _r12.y - t.dy;
  }
},
    L = {
  areEqual: areEqual,
  arePointsEqual: arePointsEqual,
  arePointsEqualish: arePointsEqualish,
  arePointsWithinTolerance: function arePointsWithinTolerance(e, t) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    return null != e && null != t && Math.abs(e.x - t.x) < p.clickTolerance * n && Math.abs(e.y - t.y) < p.clickTolerance * n;
  },
  calculateArea: calculateArea,
  calculateExtent: function calculateExtent(e) {
    if (!e || 0 === e.length) return null;

    if (1 === e.length) {
      var _t9 = e[0];

      if (isPoint(_t9)) {
        var _e2 = _t9;
        return new l({
          xmin: _e2.x - 10,
          ymin: _e2.y - 10,
          xmax: _e2.x + 10,
          ymax: _e2.y + 10,
          spatialReference: _t9.spatialReference
        });
      }

      return _t9.extent.expand(1.5);
    }

    var n = [];

    var _iterator = _createForOfIteratorHelper(e),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _t10 = _step.value;

        if (isPoint(_t10)) {
          var _e3 = _t10;

          var _r13 = new l({
            xmin: _e3.x - 10,
            ymin: _e3.y - 10,
            xmax: _e3.x + 10,
            ymax: _e3.y + 10,
            spatialReference: _t10.spatialReference
          });

          n.push(_r13);
        } else n.push(_t10);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var r = t.convexHull(t.union(n), !0);
    return (Array.isArray(r) ? r[0] : r).extent.expand(1.5);
  },
  calculateMinMaxRangeForGridCells: calculateMinMaxRangeForGridCells,
  checkMinAcreage: function checkMinAcreage(e) {
    return Boolean(e.some(function (e) {
      return C.calculateAbsRawArea(e) < D;
    }));
  },
  checkMaxAcreage: function checkMaxAcreage(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2e3;
    return e.reduce(function (e, t) {
      return e + C.calculateAbsRawArea(t);
    }, 0) > parseInt(t.toString());
  },
  createEdgeFromPoints: function createEdgeFromPoints(e, n, r) {
    var _iterator2 = _createForOfIteratorHelper(r),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _i6 = _step2.value;

        for (var _r14 = 0; _r14 < _i6.rings.length; _r14++) {
          var _o3 = null;

          for (var _t11 = 0; _t11 < _i6.rings[_r14].length; _t11++) {
            if (arePointsEqual(e, _i6.getPoint(_r14, _t11))) {
              var _ret = function () {
                var s = _findNextPoint(_r14, _t11, _i6);

                if (n.find(function (e) {
                  return arePointsEqual(e, s);
                })) {
                  _o3 = createPolyline(_getMatchingPoints(e, s, n, _i6, _r14, _t11));
                  return "break";
                }

                var a = _findPreviousPoint(_r14, _t11, _i6);

                if (n.find(function (e) {
                  return arePointsEqual(e, a);
                })) {
                  _o3 = createPolyline(_getMatchingPoints(e, a, n, _i6, _r14, _t11));
                  return "break";
                }
              }();

              if (_ret === "break") break;
            }
          }

          if (null != _o3) {
            _o3 = t.simplify(_o3);

            var _e4 = [],
                _n3 = new Set();

            var _iterator3 = _createForOfIteratorHelper(_o3.paths[0]),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var _t12 = _step3.value;

                var _r15 = _t12.toString();

                _n3.has(_r15) || _e4.push(_t12), _n3.add(_r15);
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }

            return _createPolyline([_e4], _o3.spatialReference.wkid);
          }
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return null;
  },
  createGridCells: createGridCells,
  checkIntersections: function checkIntersections(e, n, r) {
    if (!e) return !1;

    if (r && e.length > 1) {
      var _n4 = e.filter(function (e) {
        return !areEqual(e, r);
      });

      if (_n4.length > 0) {
        var _e5 = t.union(_n4);

        if (null == _e5) console.warn("Field may contain corrupt geometries.");else if (null != t.intersect(r, _e5)) return !0;
      }
    }

    var i = e.length > 0 ? t.union(e) : null,
        o = !!(n && n.length > 0) && n.some(function (e) {
      return e && null != e && null != i && null !== t.intersect(i, e);
    });
    return null != i && o;
  },
  createPolygon: function createPolygon(e) {
    return _createPolygon([e.map(function (e) {
      return [e.x, e.y];
    })], e && e.length ? e[0].spatialReference.wkid : 4326);
  },
  createPolyline: createPolyline,
  disableDoubleClickZoom: function disableDoubleClickZoom(e) {
    return v.reset(!1), e.on("double-click", function (e) {
      e.stopPropagation();
    });
  },
  disablePan: function disablePan(e) {
    return N.reset(!1), e.on("drag", function (e) {
      e.stopPropagation();
    });
  },
  disableKeyboardNavigation: function disableKeyboardNavigation(e) {
    return I.reset(!1), e.on("key-down", function (e) {
      e.stopPropagation();
    });
  },
  enableDoubleClickZoom: function enableDoubleClickZoom(e, t) {
    v.reset(!0), t && t.remove();
  },
  enablePan: function enablePan(e, t) {
    N.reset(!0), t && t.remove();
  },
  enableKeyboardNavigation: function enableKeyboardNavigation(e, t) {
    I.reset(!0), t && t.remove();
  },
  getAutoTraceNextCell: function getAutoTraceNextCell(_ref8, _ref9, o) {
    var _ref10 = _slicedToArray(_ref8, 3),
        e = _ref10[0],
        t = _ref10[1],
        n = _ref10[2];

    var _ref11 = _slicedToArray(_ref9, 2),
        r = _ref11[0],
        i = _ref11[1];

    var _moveRow = function _moveRow(n) {
      return o === M.BottomToTop ? e > 0 ? [e - 1, t, n] : [r, t, n] : e < r ? [e + 1, t, n] : [0, t, n];
    },
        _moveCol = function _moveCol(n) {
      return o === M.RightToLeft ? t > 0 ? [e, t - 1, n] : [e, i, n] : t < i ? [e, t + 1, n] : [e, 0, n];
    };

    switch (n) {
      case M.LeftToRight:
        return t < i ? [e, t + 1, n] : _moveRow(M.RightToLeft);

      case M.RightToLeft:
        return t > 0 ? [e, t - 1, n] : _moveRow(M.LeftToRight);

      case M.TopToBottom:
        return e < r ? [e + 1, t, n] : _moveCol(M.BottomToTop);

      default:
        return console.assert(n === M.BottomToTop), e > 0 ? [e - 1, t, n] : _moveCol(M.TopToBottom);
    }
  },
  getCenterPointInPolygon: function getCenterPointInPolygon(e) {
    if (null == e) return null;
    var t = e.extent.center;

    if (!e.contains(t)) {
      var _n5 = C.getPolygonParts(e).reduce(function (e, t) {
        var n = calculateArea(t);
        return n > e[1] ? [t, n] : e;
      }, [null, 0])[0];
      null != _n5 && (t = _n5.extent.center, e.contains(t) || (t = getPolyLabelPoint(_n5)));
    }

    return t;
  },
  getClusteredPoints: function getClusteredPoints(e, n) {
    var r = n.isVertexAdd,
        i = n.pointIndex,
        o = n.pathIndex,
        s = e.getPoint(o, i),
        a = [];

    if (r && i > 0) {
      var _n6 = e.getPoint(o, i - 1);

      if (t.distance(s, _n6, "feet") > p.editVertexThresholdFeet) return a;
    }

    for (var _l = 0; _l < e.rings.length; _l++) {
      for (var _n7 = 0; _n7 < e.rings[_l].length; _n7++) {
        var _r16 = arePointsEqual(e.getPoint(_l, 0), e.getPoint(_l, e.rings[_l].length - 1)) ? 4 : 3;

        if (_l === o && _n7 === i || _l !== o || e.rings[_l].length <= _r16 || 0 === _n7 && i === e.rings[_l].length - 1 || 0 === i && _n7 === e.rings[_l].length - 1) continue;
        t.distance(s, e.getPoint(_l, _n7), "feet") <= p.editVertexThresholdFeet && a.push([_l, _n7]);
      }
    }

    return a;
  },
  getCombinedBoundaries: function getCombinedBoundaries(e) {
    return C.getCombinedBoundaries(e);
  },
  getExteriorRings: function getExteriorRings(e) {
    var n;
    if (1 === e.rings.length) return t.isSimple(e) ? e.rings : (null === (n = t.simplify(e)) || void 0 === n ? void 0 : n.rings) || [];
    {
      var _n8 = e.rings.filter(function (t) {
        return e.isClockwise(t);
      }).map(function (t) {
        var n;
        return _createPolygon([t], null === (n = e.spatialReference) || void 0 === n ? void 0 : n.wkid);
      });

      return _n8.filter(function (e) {
        return _n8.filter(function (n) {
          return !t.equals(n, e);
        }).every(function (n) {
          return !t.contains(n, e);
        });
      }).map(function (e) {
        return e.rings;
      }).flat();
    }
  },
  getPolylineEdgesForPoint: function getPolylineEdgesForPoint(e, n) {
    var r = [],
        i = e.spatialReference.wkid;
    return e.paths.forEach(function (e) {
      t.intersects(_createPolyline([e], i), n) && r.push(e);
    }), r.length > 0 ? _createPolyline(r, i) : null;
  },
  getPolygonOutline: function getPolygonOutline(e) {
    return _createPolyline(e.rings, e.spatialReference.wkid);
  },
  getPolygonPoints: getPolygonPoints,
  getPolyLabelPoint: getPolyLabelPoint,
  getPolylinePoints: getPolylinePoints,
  getRandomPointInPolygon: function getRandomPointInPolygon(e) {
    if (null == e) return null;
    var t = e.extent,
        n = t.xmin,
        r = t.ymin,
        o = t.spatialReference,
        s = t.width,
        a = t.height;
    var l = null;

    for (var c = 0; c < p.sampling.randomMaxAttempts; c++) {
      if (l = new i({
        x: n + Math.random() * s,
        y: r + Math.random() * a,
        spatialReference: o
      }), e.contains(l)) return l;
    }

    return null;
  },
  getRingPointIndexes: function getRingPointIndexes(e, t) {
    var n = new Map();

    for (var _r17 = 0; _r17 < e.rings.length; _r17++) {
      n.set(_r17, []);

      for (var _i7 = 0; _i7 < e.rings[_r17].length; _i7++) {
        arePointsEqualish(e.getPoint(_r17, _i7), t) && n.get(_r17).push(_i7);
      }
    }

    return n;
  },
  getSamePoints: function getSamePoints(e, t) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
    var r = [],
        i = getPolygonPoints(e);

    for (var _o4 = 0; _o4 < t.rings.length; _o4++) {
      var _loop = function _loop(_e6) {
        var s = t.getPoint(_o4, _e6);
        !i.find(function (e) {
          return arePointsEqualish(e, s);
        }) || n && r.find(function (e) {
          return arePointsEqual(e, s);
        }) || r.push(s);
      };

      for (var _e6 = 0; _e6 < t.rings[_o4].length; _e6++) {
        _loop(_e6);
      }
    }

    return r;
  },
  getSelectionArea: function getSelectionArea(e, t) {
    return new r({
      points: [[e.x, e.y], [t.x, t.y]],
      spatialReference: {
        wkid: e.spatialReference.wkid
      }
    }).extent;
  },
  getSharedPoints: function getSharedPoints(e) {
    console.assert(e.length > 1);
    var t = [],
        n = e.map(function (e) {
      return getPolylinePoints(e);
    });

    for (var _r18 = 0; _r18 < n.length - 1; _r18++) {
      var _e7 = n.slice(_r18 + 1);

      var _iterator4 = _createForOfIteratorHelper(n[_r18]),
          _step4;

      try {
        var _loop2 = function _loop2() {
          var i = _step4.value;
          _e7.some(function (e) {
            return e.some(function (e) {
              return arePointsEqual(i, e);
            });
          }) && t.push(i);
        };

        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }

    return t;
  },
  insertPointInPoly: function insertPointInPoly(e, n) {
    for (var _r19 = 0; _r19 < e.rings.length; _r19++) {
      console.assert(arePointsEqual(e.getPoint(_r19, 0), e.getPoint(_r19, e.rings[_r19].length - 1)));

      for (var _i8 = 0; _i8 < e.rings[_r19].length - 1; _i8++) {
        var _o5 = e.getPoint(_r19, _i8),
            _s = e.getPoint(_r19, _i8 + 1),
            _t$nearestCoordinate = t.nearestCoordinate(createPolyline([_o5, _s]), n),
            _a = _t$nearestCoordinate.coordinate;

        if (arePointsEqualish(_a, n)) return void e.insertPoint(_r19, _i8 + 1, n);
      }
    }
  },
  polygonContainsAllPoints: function polygonContainsAllPoints(e, t) {
    return !t.some(function (t) {
      return !e.contains(t);
    });
  },
  polygonContainsAPoint: function polygonContainsAPoint(e, t) {
    return t.some(function (t) {
      return e.contains(t);
    });
  },
  polygonHasVertex: function polygonHasVertex(e, t) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;

    for (var _r20 = 0; _r20 < e.rings.length; _r20++) {
      if (!n || C.isPolygonRingAHole(e.rings[_r20], e.spatialReference)) for (var _n9 = 0; _n9 < e.rings[_r20].length; _n9++) {
        var _i9 = e.getPoint(_r20, _n9);

        if (arePointsEqualish(_i9, t)) return !0;
      }
    }

    return !1;
  },
  polygonIsMultipart: function polygonIsMultipart(e) {
    return C.getSimplifiedPolygonParts(e).length > 1;
  },
  polygonsSharePoint: function polygonsSharePoint(e, t) {
    return e.every(function (e) {
      return getPolygonPoints(e).some(function (e) {
        return arePointsEqual(e, t);
      });
    });
  },
  temporarilyDisableDoubleClickZoom: function temporarilyDisableDoubleClickZoom(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var n;
    v.disable(function () {
      n = e.on("double-click", function (e) {
        e.stopPropagation();
      });
    }, function () {
      n.remove();
    }, !0, t);
  },
  temporarilyDisablePan: function temporarilyDisablePan(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var n;
    N.disable(function () {
      n = e.on("drag", function (e) {
        e.stopPropagation();
      });
    }, function () {
      n.remove();
    }, !0, t);
  },
  tileExtent: function tileExtent(e, t, n) {
    var r = [],
        i = Math.abs((n.xmax - n.xmin) / e),
        o = Math.abs((n.ymax - n.ymin) / t);

    for (var _s2 = 0, _a2 = n.ymin; _s2 < t; _s2++, _a2 += o) {
      for (var _t13 = 0, _c = n.xmin; _t13 < e; _t13++, _c += i) {
        r.push(new l({
          xmin: _c,
          xmax: _c + i,
          ymin: _a2,
          ymax: _a2 + o,
          spatialReference: n.spatialReference
        }));
      }
    }

    return r;
  },
  transformTranslate: function transformTranslate(e, t, n) {
    return _createPolygon(e.rings.map(function (e) {
      return e.map(function (e) {
        return [e[0] + t, e[1] + n];
      });
    }), e.spatialReference.wkid);
  },
  union: function union() {
    for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
      e[_key] = arguments[_key];
    }

    return 1 === e.length && Array.isArray(e[0]) ? t.union(e[0]) : t.union(e);
  },
  verifyIntersections: function verifyIntersections(e) {
    var _iterator5 = _createForOfIteratorHelper(e),
        _step5;

    try {
      var _loop3 = function _loop3() {
        var n = _step5.value;
        var r = e.filter(function (e) {
          return !areEqual(e, n);
        });

        if (r.length > 0) {
          var _e8 = t.union(r);

          if (null == _e8) return {
            v: (console.warn("Field may contain corrupt geometries."), !0)
          };
          if (null != t.intersect(n, _e8)) return {
            v: !0
          };
        }
      };

      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var _ret2 = _loop3();

        if (typeof _ret2 === "object") return _ret2.v;
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }

    return !1;
  },
  wktToGeometry: function wktToGeometry(e) {
    var t = g(e),
        r = c(t);
    return n.fromJSON(r);
  },
  clone: function clone(e) {
    switch (e.type) {
      case "polygon":
      case "polyline":
      case "point":
        return e.clone();

      default:
        throw new Error("clone does not support this type of geometry.");
    }
  },
  isPolygon: function isPolygon(e) {
    return "polygon" === e.type;
  },
  isPolyline: function isPolyline(e) {
    return "polyline" === e.type;
  },
  isPoint: isPoint,
  applyPointTransformation: applyPointTransformation,
  proposedEditPolygon: function proposedEditPolygon(e, t, n, r, i, s, a) {
    var l = applyPointTransformation(n, t, a),
        c = new o(e.toJSON());
    return r ? c.insertPoint(s, i, l) : (c.setPoint(s, i, l), 0 === i ? c.setPoint(s, c.rings[s].length - 1, l) : i === c.rings[s].length - 1 && c.setPoint(s, 0, l)), c;
  }
};

export { M as A, L as G, w as M, T as S, TempDisableTimer as T, A as U, createGridCells as a, C as b, calculateMinMaxRangeForGridCells as c, formatNumber as d, k as f, S as k, E as p, b as z };